var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-shortcuts-dock" }, [
    _c("div", { staticClass: "app-shortcuts-dock-container" }, [
      _c("div", { staticClass: "app-shortcuts-dock-btn" }, [
        _c("div", { staticClass: "app-shortcuts-dock-tooltip" }, [
          _vm._v("NextGen Academy"),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: `https://nextgen-academy.ai/?token=${_vm.token}`,
              target: "_blank",
              rel: "noopener",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "/images/intro/nextgen-academy.png",
                alt: "App Icon 1",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "app-shortcuts-dock-divider" }),
      _vm._v(" "),
      _c("div", { staticClass: "app-shortcuts-dock-btn" }, [
        _c("div", { staticClass: "app-shortcuts-dock-tooltip" }, [
          _vm._v("Lingo Lango"),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: `https://lingo-lango.com/?token=${_vm.token}`,
              target: "_blank",
              rel: "noopener",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "/images/intro/LingoLango.png",
                alt: "Lingo Lango",
              },
            }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }